import axios from 'axios';

// API エラーレスポンスから表示用メッセージを取り出す（{errors:[...]} / {errors:"..."} / {error:"..."} / 文字列）。
export const extractApiErrorMessages = (data: unknown): string[] => {
  if (typeof data === 'string') {
    const trimmed = data.trim();
    return trimmed === '' || trimmed.startsWith('<') ? [] : [trimmed];
  }
  if (data && typeof data === 'object') {
    const candidate = (data as { errors?: unknown; error?: unknown }).errors
      ?? (data as { error?: unknown }).error;
    if (Array.isArray(candidate)) return candidate.filter((m): m is string => typeof m === 'string');
    if (typeof candidate === 'string') return [candidate];
  }
  return [];
};

type EnqueueSnackbar = (message: string, options: { variant: 'error' }) => void;

// 一括反映/解除・コピー・便の保存など「kind + 失敗理由」形式の通知を共通化する。
// messages（{errors:...} 由来）があれば kind ごとに1件ずつ通知し、無ければ
// 「{kind}に失敗しました」＋（includeStatus かつ status があれば）ステータス付与の1件を通知する。
// includeStatus は既定 true。解除（submitRemove）のみ既存挙動でステータス未付与のため false を渡す。
export const notifyBulkError = (
  kind: string,
  error: unknown,
  enqueueSnackbar: EnqueueSnackbar,
  options: { includeStatus?: boolean } = {},
): void => {
  const { includeStatus = true } = options;
  const messages = axios.isAxiosError(error) ? extractApiErrorMessages(error.response?.data) : [];
  if (messages.length > 0) {
    messages.forEach((m) => enqueueSnackbar(`${kind}に失敗しました: ${m}`, { variant: 'error' }));
    return;
  }
  const status = includeStatus && axios.isAxiosError(error) ? error.response?.status : undefined;
  enqueueSnackbar(`${kind}に失敗しました${status ? `（エラー ${status}）` : ''}`, { variant: 'error' });
};
